module.exports = __webpack_public_path__ + "static/media/NIN_verification_on_ecitizen.dfc673b1.png";